import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SharedCoreFormService {
  constructor() {} // public changeDetectorRef: ChangeDetectorRef
}
